<template>
  <div>
    <el-button type="primary"
               icon="el-icon-plus"
               size="small"
               style="float: right"
               @click="onCreateButtonClick">
      {{ $t('newContract') }}
    </el-button>
    <popup-add-contract
      :visible="isPopupAddContractVisible"
      :hotel-list="hotelList"
      @onClose="isPopupAddContractVisible = false"
      @onSelectedHotel="onCreateContract">
    </popup-add-contract>
  </div>
</template>

<script>
import i18nMessages from '@/translations/Contract/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { COMPANY_TYPE } from '@/configs/constant'
import PopupAddContract from '@/views/Contract/components/ManageContract/PopupAddContract'

export default {
  name: 'ContractCreateButtonComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { PopupAddContract },
  i18n: { messages: i18nMessages },
  props: {
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    salePersonList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isPopupAddContractVisible: false
    }
  },
  methods: {
    onCreateButtonClick: async function () {
      const companyData = LocalStorageFactory.getCompanyDetail()

      if (companyData.companyType === COMPANY_TYPE.STANDALONE) {
        const hotelId = this.$store.getters['general/getActiveHotelId']
        return this.onCreateContract(hotelId)
      }

      this.isPopupAddContractVisible = true
    },
    onCreateContract: function (hotelId) {
      this.$emit('onCreateContract', hotelId)
    }
  }
}
</script>

<style scoped>

</style>
